export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">
                实时更新
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-800 whitespace-nowrap">
                永久域名
              </span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              51吃瓜网官网
              <span className="block text-primary-600">全网娱乐资讯聚合平台</span>
            </h1>

            <p className="text-base md:text-lg font-heading text-foreground-600 mt-3 mb-5">
              最新最热的吃瓜现场，一站直达不迷路
            </p>

            <p className="text-sm text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
              51吃瓜网官网聚合全网娱乐八卦、影视综艺、网红动态等热门资讯，
              提供最新网站入口与永久域名。支持手机版和网页版一键直达，
              更有独立APP下载，随时随地掌握第一手吃瓜内容。
              本站每日更新频率超过200条，涵盖全品类娱乐话题，
              是千万吃瓜群众的每日必刷平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6 mb-7">
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">200+</div>
                <div className="text-xs text-foreground-500">日均更新</div>
              </div>
              <div className="w-px h-8 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-accent-600">1000万+</div>
                <div className="text-xs text-foreground-500">月活用户</div>
              </div>
              <div className="w-px h-8 bg-background-200"></div>
              <div className="text-center">
                <div className="text-2xl font-bold text-primary-600">7×24h</div>
                <div className="text-xs text-foreground-500">实时追踪</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#app')}
                className="whitespace-nowrap px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer text-sm"
              >
                立即下载APP
              </button>
              <button
                onClick={() => scrollTo('#ranking')}
                className="whitespace-nowrap px-8 py-3 border-2 border-primary-200 text-primary-700 font-medium rounded-full hover:bg-primary-50 transition-colors cursor-pointer text-sm"
              >
                查看热搜榜单
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20news%20aggregation%20concept%20with%20floating%20geometric%20shapes%20in%20warm%20coral%20red%20and%20golden%20amber%20tones%2C%20glowing%20nodes%20connected%20by%20thin%20lines%20representing%20information%20network%2C%20dark%20sophisticated%20background%20with%20subtle%20gradient%2C%20futuristic%20yet%20elegant%20aesthetic%2C%20editorial%20design%20style&width=1200&height=900&seq=hero-main-2026&orientation=landscape"
                alt="51吃瓜网官网 - 全网娱乐资讯聚合平台主视觉"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}